import React, { FunctionComponent } from 'react';

const SendArrowIcon: FunctionComponent = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="https://www.w3.org/2000/svg"
  >
    <path
      d="M16.5594 9.47164L3.49693 2.94039C3.39455 2.88919 3.27955 2.86868 3.16578 2.88132C3.05202 2.89396 2.94433 2.93922 2.85568 3.01164C2.77103 3.08259 2.70784 3.17575 2.67323 3.28064C2.63861 3.38553 2.63394 3.49799 2.65974 3.60539L4.23318 9.40633H10.9485V10.5938H4.23318L2.63599 16.377C2.61178 16.4666 2.60896 16.5608 2.62774 16.6517C2.64653 16.7427 2.6864 16.828 2.74415 16.9008C2.8019 16.9736 2.87592 17.0318 2.96026 17.0707C3.0446 17.1097 3.1369 17.1283 3.22974 17.1251C3.32269 17.1245 3.41421 17.1022 3.49693 17.0598L16.5594 10.5285C16.6567 10.4787 16.7383 10.403 16.7953 10.3098C16.8523 10.2165 16.8825 10.1094 16.8825 10.0001C16.8825 9.8908 16.8523 9.78365 16.7953 9.69041C16.7383 9.59717 16.6567 9.52147 16.5594 9.47164Z"
      fill="white"
    />
  </svg>
);

export default SendArrowIcon;
